function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Dosage, { DosagePayload } from "./dosage";
import Medication, { MedicationPayload } from "./medication";
/**
 * https://www.hl7.org/fhir/medicationrequest.html#MedicationRequest
 */
export default class MedicationRequest {
  static fromPayload(payload) {
    return new MedicationRequest({
      medication: new Medication(payload.medication),
      dosage: payload.dosage ? Dosage.fromPayload(payload.dosage) : undefined,
      comment: payload.comment
    });
  }
  constructor({
    medication,
    dosage,
    comment
  }) {
    _defineProperty(this, "medication", void 0);
    _defineProperty(this, "dosage", void 0);
    _defineProperty(this, "comment", void 0);
    this.medication = medication;
    this.dosage = dosage;
    this.comment = comment;
  }

  // FIXME: this isEqual method has been written according to the current
  // implementation of the constructor which may lead a MedicationRequest to
  // not have a Medication or a Dosage, but this may not be accurate. We
  // should look further into the usage of MedicationRequest to validate the
  // implementation in the constructor.
  isEqual(other) {
    if (this == other) return true;
    let result = true;
    if (this.medication) {
      result &&= this.medication.isEqual(other?.medication);
    } else {
      result &&= Boolean(other && this.medication == other.medication);
    }
    if (this.dosage) {
      result &&= this.dosage.isEqual(other?.dosage);
    } else {
      result &&= Boolean(other && this.dosage == other.dosage);
    }
    return result;
  }
  get label() {
    return this.medication?.description;
  }
  get dosePerTimingUnit() {
    if (this.dosage?.timing && this.dosage.doseQuantity) {
      return this.medication.dose ? this.dosage.doseQuantity * this.dosage.timing.frequency * +this.medication.dose : this.dosage.doseQuantity * this.dosage.timing.frequency || "";
    }
    return undefined;
  }
  get jsonPayload() {
    const payload = {
      medication: this.medication.jsonPayload
    };
    if (this.dosage) {
      payload.dosage = this.dosage.jsonPayload;
    }
    if (this.comment) {
      payload.comment = this.comment;
    }
    return payload;
  }
}